import React, { useState } from "react";
import { useCreatorBoostersContext } from "../../context/Creator/CreatorBoostersProvider";
import globalStyles from "../../styles/globalStyles.module.css";
import InfiniteScroll from "../../components/InfiniteScroll/InfiniteScroll";
import ShowBoosters from "../../components/Boosters/ShowBoosters/ShowBoosters";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./Archive.module.css";
import { useCollectorBoostersContext } from "../../context/Collector/CollectorBoostersProvider";
import { boosterData } from "../../services/BoosterServices";

export enum ArchiveViewMode {
  creator = 1,
  collector = 2,
}

interface ArchiveProps {
  viewModeValue?: ArchiveViewMode;
}

export const Archive: React.FC<ArchiveProps> = ({
  viewModeValue = ArchiveViewMode.creator,
}) => {
  const { archivedBoostersState } = useCreatorBoostersContext();
  const collectorBoosterContext = useCollectorBoostersContext();
  const [viewMode, setViewMode] = useState<ArchiveViewMode>(
    viewModeValue.valueOf()
  ); // Default selected value

  const { t } = useTranslation();

  const radios = [
    { name: t("creator.label"), value: 1, page: "creator" },
    { name: t("collection.label"), value: 2, page: "collector" },
  ];

  const handleAddOrRemoveCreatorBoosters = (boosters: boosterData[]) => {
    archivedBoostersState.setFilteredData(boosters);
  };

  const handleAddOrRemoveCollectorBoosters = (boosters: boosterData[]) => {
    collectorBoosterContext.boostersState.setFilteredData(boosters);
  };

  const contentMap: { [key: number]: JSX.Element } = {
    1: (
      <InfiniteScroll
        key={2}
        togglePage={archivedBoostersState.togglePage}
        loading={archivedBoostersState.loading}
        hasMore={archivedBoostersState.hasMore}
      >
        {archivedBoostersState.data.length === 0 ? (
          <div className={globalStyles.center}>{t("noContent")}</div>
        ) : (
          <ShowBoosters
            boosters={archivedBoostersState.filteredData}
            showInStore={false}
            // handleAddOrRemoveBoosters={handleAddOrRemoveBoosters}
            disableDelete={false}
            showInArchive={true}
            handleAddOrRemoveBoosters={handleAddOrRemoveCreatorBoosters}
          />
        )}
      </InfiniteScroll>
    ),
    2: (
      <InfiniteScroll
        key={2}
        togglePage={collectorBoosterContext.archivedBoostersState.togglePage}
        loading={collectorBoosterContext.archivedBoostersState.loading}
        hasMore={collectorBoosterContext.archivedBoostersState.hasMore}
      >
        {collectorBoosterContext.archivedBoostersState.data.length === 0 ? (
          <div className={globalStyles.center}>{t("noContent")}</div>
        ) : (
          <ShowBoosters
            boosters={collectorBoosterContext.archivedBoostersState.data}
            showInStore={false}
            // handleAddOrRemoveBoosters={handleAddOrRemoveBoosters}
            disableDelete={false}
            showInArchive={true}
            handleAddOrRemoveBoosters={handleAddOrRemoveCollectorBoosters}
          />
        )}
      </InfiniteScroll>
    ),
  };

  return (
    <div>
      <div className={globalStyles.pageTitle}>{t("archive")}</div>
      <div className={styles.buttonGroup}>
        {radios.map((radio, index) => (
          <Link to={`/archive/${radio.page}`} className={styles.none}>
            <div
              key={index}
              className={`${styles.toggleButton} ${
                radio.value === viewMode ? styles.active : ""
              }`}
              onClick={() => setViewMode(radio.value)}
            >
              {radio.name}
            </div>
          </Link>
        ))}
      </div>

      {contentMap[viewMode]}
    </div>
  );
};
